import type { ReactNode } from 'react';
import { maskPostalCode, unmaskPostalCode } from '@/shared/lib/postal-code';
import { MaskedInput, type MaskedInputProps } from './masked-input';

/** Campo de CEP com máscara `00000-000`; entrega só os dígitos. */
export function PostalCodeInput({
  placeholder = '00000-000',
  ...props
}: MaskedInputProps): ReactNode {
  return (
    <MaskedInput
      inputMode="numeric"
      {...props}
      placeholder={placeholder}
      mask={maskPostalCode}
      unmask={unmaskPostalCode}
    />
  );
}
